import { createApp } from 'vue'
import App from './App.vue'

const mountAccountMenu = document.querySelector('#account-menu')

if (mountAccountMenu) {
    const props = {
        profileUrl: mountAccountMenu.dataset.profileUrl,
        emailUrl: mountAccountMenu.dataset.emailUrl,
        passwordUrl: mountAccountMenu.dataset.passwordUrl,
        logoutUrl: mountAccountMenu.dataset.logoutUrl,
    }

    createApp(App, props).mount('#account-menu')
}
